export default __webpack_public_path__ + "static/media/ESG_Dataset_Import_Variable_Template.843f5b09.xlsx";